export const Dashboard = () => (
  <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(-2 -2)" fill="none" fillRule="evenodd">
      <path d="M10 14a1 1 0 011 1v6a1 1 0 01-1 1H3a1 1 0 01-1-1v-6a1 1 0 011-1h7zm11-5a1 1 0 011 1v11a1 1 0 01-1 1h-7a1 1 0 01-1-1V10a1 1 0 011-1h7zM10 2a1 1 0 011 1v8a1 1 0 01-1 1H3a1 1 0 01-1-1V3a1 1 0 011-1h7zm11 0a1 1 0 011 1v3a1 1 0 01-1 1h-7a1 1 0 01-1-1V3a1 1 0 011-1h7z" />
    </g>
  </svg>
)
